"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const react_redux_1 = require("react-redux");
const expertsSlice_1 = require("../../../../../../../redux/slices/expertsSlice");
const modalsSlice_1 = require("../../../../../../../redux/slices/modalsSlice");
require("./languages.scss");
const Languages = (props) => {
    var _a;
    const { expert } = props;
    const { languages = [] } = expert;
    const mainService = (_a = expert === null || expert === void 0 ? void 0 : expert.mainService) === null || _a === void 0 ? void 0 : _a.name;
    const openModal = () => props.triggerModal({ key: 'experts.languages', val: true });
    return expert && mainService === 'Court Interpreter' ? (react_1.default.createElement(core_1.Paper, { className: 'paper admin-blocks languages', square: true },
        react_1.default.createElement("div", { className: "header-add" },
            react_1.default.createElement("h5", { className: "mb-0" }, "Languages"),
            react_1.default.createElement("div", { className: 'align-right profile-add-sec-license', onClick: () => openModal() }, "Add")),
        (languages === null || languages === void 0 ? void 0 : languages.length) ? languages.filter(l => !l.deleted).map((lang, index) => {
            return (react_1.default.createElement(core_1.Grid, { container: true, className: "lang-container", key: index, spacing: 3 },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, style: { display: 'flex' }, className: "lang-item" },
                    react_1.default.createElement("div", { className: "lang-info" },
                        react_1.default.createElement("p", null,
                            react_1.default.createElement("strong", null, lang.name)),
                        react_1.default.createElement("p", null,
                            lang.levelName,
                            lang.cert && react_1.default.createElement("span", null,
                                " Certificate N: ",
                                lang.cert))),
                    react_1.default.createElement("div", { className: 'align-right', style: { flex: 1, alignItems: 'start', paddingTop: '15px' } },
                        react_1.default.createElement("div", { className: "edit-data", style: { cursor: 'pointer' }, onClick: () => {
                                props.editLanguage({ index, lang });
                                openModal();
                            } })))));
        }) : react_1.default.createElement("p", null, "Please add Language."))) : (react_1.default.createElement(react_1.Fragment, null));
};
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        expert: experts.editableExpert || experts.expert
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data)),
        editLanguage: (data) => dispatch(expertsSlice_1.editLanguage(data)),
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Languages);
